import type Phaser from 'phaser';
import type { MowerId } from '../../content/mowers';
import { mowerIconOffset } from '../render/mowerArt';

/**
 * Centers a mower icon (an east-facing frame, already scaled) on its visible shape rather than
 * its deck, so mowers with handles and bags sit square in their chips.
 */
export function centerMowerIcon<T extends Phaser.GameObjects.Image>(img: T, id: MowerId): T {
  const o = mowerIconOffset(id);
  return img.setPosition(img.x + o.x * img.scaleX, img.y + o.y * img.scaleY);
}
